"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Cloud, Server, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AvStreamConnectHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="avstream-connect-hero" className="relative bg-background py-12 md:py-16 overflow-hidden flex items-center">
      {/* Background Glows */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-lg bg-primary/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-lg bg-secondary/5 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`flex flex-col items-center text-center max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="secondary" className="mb-8 px-4 py-1.5 text-sm bg-primary/10 text-primary hover:bg-primary/20 border-none">
            <span className="flex items-center gap-2">
              <span className="relative flex size-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-lg size-2 bg-primary"></span>
              </span>
              Nueva Solución Híbrida
            </span>
          </Badge>

          {/* Product Logo / Branding */}
          <div className="mb-10 relative">
            <div className="absolute inset-0 bg-white/50 blur-2xl rounded-lg -z-10"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/avstream_connect_logo_large.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/avstream_connect_logo_large.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/avstream_connect_logo_large.png-wvc-sizes" alt="AvStream Connect Powered by Grandstream" className="h-24 md:h-32 lg:h-40 object-contain drop-shadow-sm" loading="eager" />
            <p className="text-xs font-bold tracking-widest text-muted-foreground/60 mt-4 uppercase">
              POWER BY GRANDSTREAM
            </p>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground tracking-tight mb-6 leading-tight">
            Comunicación sin límites para <span className="text-primary">equipos modernos</span>
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-10 leading-relaxed">
            La solución definitiva que combina la seguridad y control del entorno on-premise con la flexibilidad y escalabilidad de la nube.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto h-12 px-8 text-base group">
              <Link to="#">
                Solicitar Demo
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-12 px-8 text-base border-border hover:bg-accent">
              <Link to="#">
                Ver Solución
              </Link>
            </Button>
          </div>

          {/* Feature Highlights */}
          <div className="mt-8 md:mt-10 pt-8 border-t border-border/50 flex flex-wrap justify-center gap-6 md:gap-12 text-sm font-medium text-muted-foreground">
            <div className="flex items-center gap-2">
              <div className="p-2 rounded-md bg-primary/10 text-primary">
                <Server className="size-4" />
              </div>
              <span>On-Premise Seguro</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="p-2 rounded-md bg-secondary/10 text-secondary">
                <Cloud className="size-4" />
              </div>
              <span>Cloud Flexible</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="p-2 rounded-md bg-accent text-accent-foreground">
                <ShieldCheck className="size-4" />
              </div>
              <span>Alta Disponibilidad</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}